/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

import { RendererProvider } from "@atlassiansox/bxp-content-framework";

import {
    useAnalytics,
    FooterContextProvider,
    AnalyticsAttributesProvider
} from "../../components";
import { PageModel } from "../../models";
import { renderViewModels, renderViewModel } from "../../render-view-model";
import { MapModelToProps } from "../../utils";

export type PageProps = MapModelToProps<PageModel>;

const Page = ({ model }: PageProps) => {
    const { sendPageEvent } = useAnalytics();
    const {
        entryTitle,
        title,
        route,
        variant = undefined, // Default to undefined if not present
        header,
        sections = [],
        footer,
        noIndexTag
    } = model.content;

    // Debug logging
    console.log(
        "Page component rendering:",
        JSON.stringify({
            entryTitle,
            title,
            routePath: route.content.path,
            variant,
            hasHeader: !!header,
            headerType: header?.type,
            headerId: header?.id,
            sectionsCount: sections.length,
            hasFooter: !!footer
        })
    );

    if (header) {
        console.log("Header model:", JSON.stringify(header));
    } else {
        console.warn("No header in pageModel.content");
    }

    const sharedPageAttributes = {
        stack: "arcadia",
        isIndexed: !noIndexTag
    };

    useEffect(() => {
        sendPageEvent("", {
            ...sharedPageAttributes,
            path: route.content.path,
            title,
            pageVariant: variant
        });
    }, [route.content.path, sendPageEvent, title, variant]);

    return (
        <RendererProvider renderer={renderViewModel}>
            <FooterContextProvider>
                <AnalyticsAttributesProvider
                    value={{
                        ...sharedPageAttributes,
                        labelEnglish: entryTitle
                    }}
                >
                    {header && renderViewModel(header)}
                    <main id="skip-target" tabIndex={-1}>
                        {renderViewModels(sections)}
                    </main>
                    {footer && renderViewModel(footer)}
                </AnalyticsAttributesProvider>
            </FooterContextProvider>
        </RendererProvider>
    );
};

export default Page;
